import type { Reservation } from '@restaurant/api-client';
import { ArrivalStatus, ReservationStatus } from '@restaurant/types';

type SlotFields = Pick<Reservation, 'id' | 'time' | 'duration' | 'status' | 'arrivalStatus'>;

export function holdsSlot(r: Pick<Reservation, 'status' | 'arrivalStatus'>): boolean {
  if (r.status !== ReservationStatus.PENDING && r.status !== ReservationStatus.CONFIRMED) {
    return false;
  }
  return r.arrivalStatus !== ArrivalStatus.NO_SHOW && r.arrivalStatus !== ArrivalStatus.RESCHEDULED;
}

export function overlappingReservations<T extends SlotFields>(
  target: SlotFields,
  candidates: readonly T[],
): T[] {
  if (!holdsSlot(target)) return [];
  const start = Date.parse(target.time);
  const end = start + target.duration * 60_000;
  return candidates.filter((r) => {
    if (r.id === target.id || !holdsSlot(r)) return false;
    const otherStart = Date.parse(r.time);
    const otherEnd = otherStart + r.duration * 60_000;
    return otherStart < end && otherEnd > start;
  });
}
